import {IUserData} from 'modules/user/models';

type TAuthContinuation = (user: IUserData) => void | Promise<void>;

let pendingContinuation: TAuthContinuation | null = null;

export const setPendingAuthContinuation = (continuation: TAuthContinuation) => {
    pendingContinuation = continuation;
};

export const hasPendingAuthContinuation = (): boolean => null !== pendingContinuation;

export const consumePendingAuthContinuation = (): TAuthContinuation | null => {
    const continuation = pendingContinuation;
    pendingContinuation = null;
    return continuation;
};
